import { createSlice } from '@reduxjs/toolkit';
import { 
  fetchAllBackyardMedia, 
  insertBackyardMedia, 
  editBackyardMedia, 
  deleteBackyardMedia 
} from './BackyardThunks';

// Slice
const backyardSlice = createSlice({
  name: 'backyard',
  initialState: {
    fetchBackyardPending: false,
    backyardList: null,
    pagination: null,
    fetchBackyardRejected: null,

    insertBackyardPending: false,
    insertBackyardFulfilled: null,
    insertBackyardRejected: null,

    editBackyardFulfilled: null,
    editBackyardRejected: null,
    editBackyardPending: false,

    deleteBackyardPending: false,
    deleteBackyardFulfilled: false,
    deleteBackyardRejected: null,

    status: 'idle',
    error: null,
  },
  reducers: {
    resetInsertBackyard: (state) => {
      state.insertBackyardPending = false;
      state.insertBackyardFulfilled = null;
      state.insertBackyardRejected = null;
    },
    resetEditBackyard: (state) => {
      state.editBackyardFulfilled = null;
      state.editBackyardRejected = null;
      state.editBackyardPending = false;
    },
    resetDeleteBackyard: (state) => {
      state.deleteBackyardFulfilled = false;
      state.deleteBackyardRejected = null;
      state.deleteBackyardPending = false;
    },
  },
  extraReducers: (builder) => {
    // Fetch Backyard Media
    builder
      .addCase(fetchAllBackyardMedia.pending, (state) => {
        state.fetchBackyardPending = true;
        state.fetchBackyardRejected = null;
      })
      .addCase(fetchAllBackyardMedia.fulfilled, (state, action) => {
        state.fetchBackyardPending = false;
        state.backyardList = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchAllBackyardMedia.rejected, (state, action) => {
        state.fetchBackyardPending = false;
        state.fetchBackyardRejected = action.payload;
      })
      
      // Insert Backyard Media
      .addCase(insertBackyardMedia.pending, (state) => {
        state.insertBackyardPending = true;
        state.insertBackyardFulfilled = null;
        state.insertBackyardRejected = null;
      })
      .addCase(insertBackyardMedia.fulfilled, (state, action) => {
        state.insertBackyardPending = false;
        state.insertBackyardFulfilled = action.payload;
      })
      .addCase(insertBackyardMedia.rejected, (state, action) => {
        state.insertBackyardPending = false;
        state.insertBackyardRejected = action.payload;
      })

      // Edit Backyard Media
      .addCase(editBackyardMedia.pending, (state) => {
        state.editBackyardPending = true;
        state.editBackyardFulfilled = null;
        state.editBackyardRejected = null;
      })
      .addCase(editBackyardMedia.fulfilled, (state, action) => {
        state.editBackyardPending = false;
        state.editBackyardFulfilled = action.payload;
      })
      .addCase(editBackyardMedia.rejected, (state, action) => {
        state.editBackyardPending = false;
        state.editBackyardRejected = action.payload;
      })
      
      // Delete Backyard Media
      .addCase(deleteBackyardMedia.pending, (state) => {
        state.deleteBackyardPending = true;
      })
      .addCase(deleteBackyardMedia.fulfilled, (state, action) => {
        state.deleteBackyardPending = false;
        state.deleteBackyardFulfilled = true;
      })
      .addCase(deleteBackyardMedia.rejected, (state, action) => {
        state.deleteBackyardPending = false;
        state.deleteBackyardRejected = action.payload;
      })
  },
});

export const { resetInsertBackyard, resetEditBackyard, resetDeleteBackyard } = backyardSlice.actions;

export default backyardSlice.reducer;
